var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-swiper',{ref:"routeslider",staticClass:"route-cards",attrs:{"params":{
        speed:500,
        spaceBetween: -80,
        lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 2
        }
    }}},_vm._l((this.routes),function(route){return _c('f7-swiper-slide',{key:route.id},[_c('route-card',{attrs:{"route":route}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }